export default __webpack_public_path__ + "static/media/ROX_4745.64ae7c91.jpg";